var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "poppins broker-shell",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('nav-bar-admin'), _c('popup-handler'), _c('loading-page'), _c('karta-kalendar'), _vm.loading ? _c('div', {
    staticClass: "bcg-loading"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _c('router-view', {
    staticStyle: {
      "min-height": "100%"
    }
  }), _c('success-message-handler')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }